//using plain javascript
window.addEventListener('pageshow', function(event) {
	if (event.persisted) {
		// window.location.reload();
		setTimeout(function() {
			var images = document.querySelectorAll('.intersection-invisible');
			for (var i = 0; i < images.length; i++) {
				images[i].classList.add('intersection-visible');
			}
		}, 0);
		// fixImagesIfPersisted();
	}
});

let intersectionObserver;

function setIntersectionObserver() {
	var images = document.querySelectorAll('.intersection-invisible');
	if(images.length > 0) {
		if(!intersectionObserver) {
			intersectionObserver = new IntersectionObserver(function(entries) {
				var counter = 0;
				entries.forEach(function(entry) {
					if (entry.intersectionRatio > 0) {
						setTimeout(function() {
							entry.target.classList.add('intersection-visible');
						}, counter * 125);
					}
					counter++;
				});
			},{
				// root: document.body,
				// threshold: 0.1
				rootMargin: '-100px 0px'
			});
		}

		images.forEach(image => {
			intersectionObserver.observe(image);
		});
	}
}

document.addEventListener('DOMContentLoaded', function() {
	setIntersectionObserver();
});
